import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// load settings from localstorage on app start
const persistedSettings = Object.assign(
  {
  // Default Id of the google cal resource which is presented
    defaultResourceId: '',
    // refresh the calender data automatically in this interval
    refreshInterval: 120,
    // jump back to default view after this seconds
    defaultViewTimeout: 120,
    // if true, jump to default room view after defaultViewTimeout seconds
    autoJumpToDefaultRoom: true,
    // list of possible event owners
    members: ['Funkhaus', 'BDS', 'Bee42', 'Enervolution', 'Pflegix', 'innogy', 'img.ly', 'WerkX', 'extern']
  }, JSON.parse(localStorage.getItem('settings')))

console.log('Loaded Settings: ', persistedSettings)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    // store app settings in a module, which are persisted to local Storage
    settings: {
      namespaced: true,
      state: persistedSettings,
      mutations: {
        update (state, settings) {
          Object.assign(state, settings)
          localStorage.setItem('settings', JSON.stringify(settings))
          console.log('Persisted Settings: ', settings)
        }

      }
    }
  },

  state: {
    isSignedIn: false,
    resourceCalendars: [],
    currentResourceId: '',
    resourceEvents: {},
    updateInProgress: true
  },
  /* eslint no-param-reassign: "error" */
  mutations: {
    setIsSignedIn (state, isSignedIn) {
      state.isSignedIn = isSignedIn
    },
    setResourceCalendars (state, resourceCalendars) {
      state.resourceCalendars = resourceCalendars
      // for (let index = 0; index < resourceCalendars.length; index++) {
      //   const resourceCalendar = resourceCalendars[index]
      //   Vue.set(state.resourceCalendars, index, resourceCalendar)
      // }
    },
    setCurrentResourceCalendar (state, currentResourceCalendar) {
      state.currentResourceCalendar = currentResourceCalendar
    },
    setCurrentResourceId (state, resourceId) {
      state.currentResourceId = resourceId
    },
    setResourceEvents (state, { resourceId, events }) {
      // state.resourceEvents[resourceId] = events
      Vue.set(state.resourceEvents, resourceId, events)
    },
    updateInProgress (state, isInProgress) {
      state.updateInProgress = isInProgress
    }

  },
  actions: {
    updateSignState (context) {
      context.commit('setIsSignedIn', Vue.$googleCalendarService.isSignedIn())
    },

    updateRooms (context) {
      context.commit('updateInProgress', true)
      Vue.$googleCalendarService.getResourceCalendars().then((resourceCalendars) => {
        context.commit('updateInProgress', false)
        context.commit('setResourceCalendars', resourceCalendars)
        context.dispatch('updateResourceEvents')
      })
    },
    signIn (context) {
      Vue.$googleCalendarService.signIn().then(() => {
        context.dispatch('updateSignState')
        context.dispatch('updateRooms')
      })
    },
    signOut (context) {
      Vue.$googleCalendarService.signOut().then(() => {
        context.commit('setIsSignedIn', false)
        context.commit('setResourceCalendars', [])
      })
    },
    updateResourceEvents (context) {
      context.commit('updateInProgress', true)
      context.state.resourceCalendars.forEach(resource => {
        Vue.$googleCalendarService.getEventsByCalendarIdOfDay(resource.id, new Date()).then((events) => {
          context.commit('updateInProgress', false)
          context.commit('setResourceEvents', { resourceId: resource.id, events })
        })
      })
    },

    switchResource (context, resourceId) {
      context.commit('setCurrentResourceId', resourceId)
    }
  },
  getters: {
    currentEvents (state) {
      if (state.resourceEvents && state.currentResourceId) {
        return state.resourceEvents[state.currentResourceId]
      } else {
        return []
      }
    }
  }
})

export default store
